import { useState, useEffect } from 'react';

interface UseResponsiveTextProps {
  text: string;
  maxLength?: number;
  baseFontSize?: string;
}

export const useResponsiveText = ({ 
  text, 
  maxLength = 20, 
  baseFontSize = 'text-base' 
}: UseResponsiveTextProps) => {
  const [fontSize, setFontSize] = useState(baseFontSize);

  useEffect(() => {
    const textLength = text?.length || 0;
    
    if (textLength <= 10) {
      setFontSize('font-size-16px');
    } else if (textLength <= 15) {
      setFontSize('font-size-14px');
    } else if (textLength <= 20) {
      setFontSize('font-size-12px');
    } else if (textLength <= 25) {
      setFontSize('font-size-10px');
    } else {
      setFontSize('font-size-10px');
    }
  }, [text]);

  return fontSize;
};

export default useResponsiveText;
